export function arrayIsElExist<T>(arr: T[], el: T, key: keyof T) {
  return Boolean(arr.some((arrEl) => arrEl[key] === el[key]));
}

export default arrayIsElExist;
